<template>
  <div>
    <default-avatar
        :size="size"
        :name="name"
        :id="id"
        :image="image"
        :fallbackImage="fallbackImage" />
    <img
        v-if="topPro"
        :style="style"
        src="@/assets/TopPro.svg"
        :height="size/3"
        :width="size/3"
    >
    <img
        v-else-if="fiveStar"
        :style="style"
        src="@/assets/FiveStarPro.svg"
        :height="size/2.5"
        :width="size/2.5"
        selenium="public-profile-five-stars-badge"
    >
  </div>
</template>

<script>
import DefaultAvatar from '@/components/Avatar';

const DEFAULT_AVATAR = require('./assets/default.svg');

export default {
  name: 'pro-avatar',
  components: {
    DefaultAvatar,
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 50,
    },
    id: {
      type: Number,
      default: 0,
    },
    fiveStar: {
      type: Boolean,
      default: false,
    },
    topPro: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      fallbackImage: DEFAULT_AVATAR,
    };
  },
  computed: {
    style () {
      return {
        position: 'relative',
        left: `${this.size / 2}px`,
        top: `-${this.size / 4}px`,
      };
    },
  },
};
</script>
